import { FileCopy as FileCopyIcon } from "@mui/icons-material";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../components/formatNumber";
import {BotBlogrButton} from "./index";
const ReferralPanel = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state?.auth.userInfo);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const copyReferralLink = () => {
    navigator.clipboard
      .writeText(
        `${window.location.origin}/signup?referral=${userInfo.unique_id}`
      )
      .then(() => {
        setTooltipOpen(true);
        setTimeout(() => {
          setTooltipOpen(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="rounded-lg shadow-default bg-white px-4 py-4 mt-3">
      {userInfo.plan === "Demo" ? (
        <div>
          <p className="text-black text-xl font-bold">
            {t(
              "your-friends-could-like-this-demo-friendly",
              "Ton réseau pourrait aimer cette démo !"
            )}
          </p>
          <p className="block font-sans text-sm antialiased font-light leading-relaxed text-inherit mt-3">
            {t(
              "share-demo-link-to-gain-advantages-on-launch-friendly",
              "Tu aimes la démo et connais des personnes qui seraient intéressées à l'idée de la tester ? Invite-les via ton propre lien pour que toi et tes invités profitent d'avantages supplémentaires au lancement officiel !"
            )}
          </p>
        </div>
      ) : (
        <div>
          <p className="text-black text-xl font-bold">
            {t(
              "gain-and-offer-3-seo-tokens-freely",
              "Gagne 3 jetons d'analyses SEO + offre-en 3 GRATUITEMENT !"
            )}
          </p>
          <p className="block font-sans text-sm antialiased font-light leading-relaxed text-inherit mt-3">
            {t(
              "share-link-to-gain-3-seo-tokens-freely",
              "Tu connais des personnes qui seraient intéressées par BotBlogR ? S'ils s'inscrivent directement avec ton propre lien, toi et le nouvel inscrit gagnez 3 jetons d'analyse SEO supplémentaires !"
            )}
          </p>
          {/* <p>
            <a className="font-semibold mt-3 block" href="/affiliate-program">
              {t(
                "learn-more-affiliate-program",
                "En savoir plus sur notre programme d'affiliation"
              )}
            </a>
          </p> */}
        </div>
      )}

      <div className="relative left-1/2 -translate-x-1/2">
        <Tooltip
          title={t("link-copied", "Lien copié !")}
          open={tooltipOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          arrow
          placement="top"
        >
        
          <BotBlogrButton
  variant="primary"
  onClick={copyReferralLink}
  icon={FileCopyIcon}
>
  {t("copy-my-link", "Copier mon lien !")}
</BotBlogrButton>
        </Tooltip>
      </div>
      <div className="my-3">
        <div className="flex  flex-col justify-center  items-center">
          <div className="rounded-lg h-7 text-blue-400 flex items-center justify-center flex-row p-4 gap-1">
            <EqualizerIcon />
            <p className="text-2xl font-semibold">
              {formatNumber(
                userInfo?.total_referral_tokens
                  ? userInfo?.total_referral_tokens
                  : 0
              )}
            </p>
          </div>
          <p className="text-sm  mt-2 ">
            {t("total-seo-referral-tokens", "Total referral tokens")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReferralPanel;
